import labels from "webforms/formio/_labels";

export default [{ groupBy: "Type", title: labels.type }];
